import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'antd';
import moment from 'moment';

import { massPropTypes } from '../../propTypes/mass';

import styles from './MassListCell.module.scss';

const hasAnyMass = (masses, dayToSearch) => {
  return masses[dayToSearch] && masses[dayToSearch].length > 0;
};

export const checkIfMomentValueInThePast = momentValue => {
  return momentValue.clone().startOf('day').isBefore(moment().startOf('day'));
};

const MassListCell = ({ momentValue, massesByDay }) => {
  const formattedDay = momentValue.format('YYYY-MM-DD');
  const isValueInThePast = checkIfMomentValueInThePast(momentValue);
  const hasMasses = hasAnyMass(massesByDay, formattedDay);

  if (hasMasses && !isValueInThePast) {
    if (
      massesByDay[formattedDay].some(
        ({
          availableMassOfferings,
          hasUnlimitedOfferings,
          unavailableBecauseOfMinimumFromDate,
          unavailableBecauseOfEvenDistribution,
        }) =>
          (hasUnlimitedOfferings || availableMassOfferings > 0) &&
          !unavailableBecauseOfMinimumFromDate &&
          !unavailableBecauseOfEvenDistribution,
      )
    ) {
      return <Badge status="success" className={styles.badge} />;
    }

    return <Badge status="error" className={styles.badge} />;
  }

  return null;
};

MassListCell.propTypes = {
  momentValue: PropTypes.instanceOf(moment),
  massesByDay: PropTypes.objectOf(PropTypes.arrayOf(massPropTypes)),
};

export default MassListCell;
